if (slideAutoScroll) {
   slideDuration = 4000;
} else {
   slideDuration = 0;
}

jQuery(window).bind("load", function() {
	jQuery('#featured-slides').cycle({
	    cleartypeNoBg: true,
	    fx:     'scrollHorz', 
		easing: 'easeOutQuart',
		pause:  1,
	    speed:  1000, 
	    timeout: slideDuration, 
	    next:   '#next2', 
	    prev:   '#prev2' 
	});
});

jQuery(document).ready(function(){

jQuery("a[rel='lightbox']").colorbox({transition:"elastic"});

jQuery('.go-back a').click(function() {
	javascript:history.back();
	return false;
});


jQuery('#search-input').click(function() {
	jQuery(this).val('');
});


jQuery('#main-nav li.has-menu').hover(function() {
	jQuery(this).addClass('menu-active');
}, function() {
	jQuery(this).removeClass('menu-active');
});

jQuery('#cart-note a').click(function() {
	jQuery('#note').toggleClass('hide').focus(); 
	return false;
});

});